import { useNavigation } from '@react-navigation/native'
import React from 'react'

import { ImageUpload } from 'pages/CoachOnboarding/subcomponents/ImageUpload'

import { BottomSheetNav } from 'widgets/BottomSheetNav'
import { Box } from 'widgets/Box'

import { links } from 'utils/constants'

import { ProgramType } from 'types/program'

export const UpspaceImagePage = () => {
  const navigation = useNavigation<any>()

  const handleNextPress = () => {
    navigation.navigate(links.UPSPACE_NEXT_PAGE)
  }

  return (
    <Box testID='UpspaceImagePage' flexDirection='column' backgroundColor='v2primary' flex={1}>
      <BottomSheetNav withBack withNext onNextPress={handleNextPress} />
      <ImageUpload
        type={ProgramType.GROUP}
        promptTitle='Give your Group some show with a cover image'
        onNext={handleNextPress}
      />
    </Box>
  )
}
